import { Logger } from 'kersplunk';
import { APP_CONFIG } from '../constants/APP_CONFIG';
import { SDUser } from '../models/SDUser';

const LOGGER_TYPES = ['info', 'warn', 'error', 'track'] as const;

export type LoggerState = {
  user?: SDUser;
  impersonatedUser?: SDUser;
};
let loggerState: LoggerState = {};
export const injectStateIntoLogger = (newState: LoggerState) => (loggerState = newState);

export const logger = Logger.create(
  {
    autoRetryDuration: 10000,
    splunkUrl: 'https://http-inputs-coxauto.splunkcloud.com/services/collector/event',
    authToken: '202387e0-6c67-46af-a98f-9deefe36acef',
    splunkMeta: {
      index: 'man_app',
      source: 'app:seller-dashboard-ui',
      sourcetype: '_json'
    },
    enabled: !['test'].includes(APP_CONFIG.build.environment),
    interceptor: log => {
      const enhancedLog = {
        ...log,
        // eslint-disable-next-line camelcase
        cai_app: 'seller-dashboard-ui',
        // eslint-disable-next-line camelcase
        cai_environment: APP_CONFIG.build.environment,
        meta: {
          build: APP_CONFIG.build,
          user: loggerState.user,
          impersonatedUser: loggerState.impersonatedUser,
          clientTime: new Date(),
          location: window.location.href,
          userAgent: navigator.userAgent
        }
      };
      return enhancedLog;
    }
  },
  ...LOGGER_TYPES
);

//////////////////////////////////////
// Logging message validation.
//////////////////////////////////////
type LoggerInstance = typeof logger;
type LoggerFunction = LoggerInstance[typeof LOGGER_TYPES[number]];
const verifyLogFormatWrapper =
  (loggerFunc: LoggerFunction): LoggerFunction =>
  (message, details) => {
    if (message.includes(' ')) {
      throw new Error(
        `Invalid log message: ${message}\n\nLog messages cannot be descriptive phrases but namespaced event keys in the format of "<noun>:<action>". eg: button:click, app:login, app:navigate. If details need to be provided with your log, it should be provided in data-form as an object. eg: logger.info('button:click', {text: e.target.textContent}).`
      );
    }
    loggerFunc(message, details);
  };

if (['dev', 'test'].includes(APP_CONFIG.build.environment)) {
  // eslint-disable-next-line functional/immutable-data
  LOGGER_TYPES.forEach(loggerType => (logger[loggerType] = verifyLogFormatWrapper(logger[loggerType])));
}
